function confluence(c) {
  if (c || c == 0) return c.toFixed(2) + "%";
  else return "missing";
}

export default confluence;
